<template>
    <div class="head">
        <div class="contain">
            <div class="tips levelCenter">
                <img src="@/assets/select.png" alt="">
                号卡办理成功
            </div> 
            <div class="tips levelCenter">
                <img src="@/assets/select.png" alt="">
                运营商实名审核
            </div> 
            <div class="tips" style="flex-direction: column; margin-top: 0.72rem;">
                <div class="levelCenter">
                    <img src="@/assets/noselect.png" alt="">
                    受理成功
                </div> 
                <div class="reminder">快递寄出后，请按照快递引导激活方式使用</div>
            </div>
              <van-button round type="info" class="btnButton" @click="goBack()">查询订单信息</van-button>
        </div>
    </div>
</template>
<script>
export default {
 methods:{
        goBack(){
            this.$router.push({name:'orderSearch'})
        }
 }

}
</script>

<style lang="less" scoped>
    .head{
        width: 100%;
        height: 100vh;
        padding: 0.32rem;
        box-sizing: border-box;
        background-color: #1f3ac3;
        display: flex;
        justify-content: center;
        align-items: center;
        .contain{
            width:90%;
            background: #e5e9ff;
            border-radius: 10px;
            padding: 30px 30px;
            box-sizing: border-box;
            .tips{
                display: flex;
                font-size: 15px;
                color: #2e2e2e;
                font-weight: bold;
                margin-bottom: 50px;
                img{
                    width: 15px;
                    height:15px;
                    margin-right: 0.26rem;
                }
                .reminder {
                    font-size:12px;
                    color: #2e2e2e;
                    margin-top:20px;
                    padding-left:20px;
                }
            }
            .levelCenter{
                display: flex;
                align-items: center;
            }
        }
    }
</style>